import { render, staticRenderFns } from "./DonutHubFailedDelivery.vue?vue&type=template&id=51b84518&lang=pug&"
import script from "./DonutHubFailedDelivery.vue?vue&type=script&lang=ts&"
export * from "./DonutHubFailedDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./DonutHubFailedDelivery.vue?vue&type=style&index=0&id=51b84518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports